export const proposals = state => state.proposals.items
export const proposalsTotal = state => state.proposals.total
export const proposalById = state => id => _.find(proposals(state), {id: parseInt(id)})
export const proposalsByCompanyId = state => id => _.filter(proposals(state), {company_id: id})
export const contactProposalsByContactId = state => contact_id => {
    contact_id = parseInt(contact_id)
    return _.filter(proposals(state), {contact_id})
}
export const proposalNameById = state => id => {
    let project = proposalById(state)(id)
    return project ? `Proposal #${project.id}` : '–'
}
export const proposalsByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let proposal = proposalById(state)(id)
        if (proposal) res.push(proposal)
        return res
    }, [])
}
export const convertedProposals = state => _.filter(proposals(state), (project) => project.type === 'project')

export const projectPmAssignedMessage = state => `Hi [contact.full_name],<br><br>My name is [PM],
and I will be your dedicated project manager for this job. Please fill out the attached
Project Information Sheet (PIS) which outlines the information that we need to start preparing the forms.
In addition, please email all the PDF plans you have for this project.<br><br>Please contact us should you have any questions filling out the form.`

export const proposalReminderMessage = state => {
    return `
Hello [contact.full_name],<br><br>I just wanted to check on the status of the [project.full_name] proposal sent over on [date] for our expediting services.
Are we still under consideration or should I close out this particular project on our end?<br><br>If you have any questions concerning our proposal or there's anything else we can help you with, please don't hesitate to contact us.
    `
}

export const proposalInitialMessage = state => {
    return `
Hello [contact.full_name],<br><br>As per our conversation and the information received to date, I have
attached our service proposal for your project. Feel free to contact us
with any questions or if you need any additional information.<br><br>
Thank you again for the opportunity!
    `
}
export const proposalRequestSignatureMessage = state => {
    return `
Hello [contact.full_name],<br><br>As per our conversation and the information received to date, I have
attached our service proposal for your project. Feel free to contact us
with any questions or if you need any additional information.<br><br>
[docusign_link]<br><br>
Thank you again for the opportunity!
    `
}

export const proposalStatusById = state => id => {
    let statuses = {
        1: 'Awaiting Signature',
        6: 'Approved',
        7: 'Declined',
        12: 'On Hold',
        3: 'Dropped'
    }

    return statuses[id]
}

export const proposalRemindMessage = state => {
    return `
    Hello [contact.full_name],
    <br><br>
    I just wanted to check on the status of the [project.full_name] proposal sent over on [date] for our expediting services. Are we still under consideration or should I close out this particular project on our end?
    <br><br>
    [docusign_link]
    <br><br>
    If you have any questions concerning our proposal or there's anything else we can help you with, please don't hesitate to contact us.
    `
}

//export const proposalMessage = state => {
//    return `
//Hello [contact.full_name],<br><br>As per our conversation and the information received to date, I have
//attached our service proposal for your project. Feel free to contact us
//with any questions or if you need any additional information.<br><br>
//Thank you again for the opportunity!
//    `
//}
//export const proposalReminderMessage = state => {
//    return `
//I just wanted to check on the status of the [project.full_name] proposal sent over on [date] for our expediting services.
//Are we still under consideration or should I close out this particular project on our end?<br><br>
//
//If you have any questions concerning our proposal or there's anything else we can help you with, please don't hesitate to contact us.
//    `
//}
